{
  "es": {
    "decision": {
      "actions": {
        "add": "Añadir",
        "addDocument": "Añadir documento",
        "addUnits": "Unidades",
        "approve": "Aprobar",
        "autoCloseAfterApproval": "Cierre automático tras la aprobación",
        "autoCloseAfterApprovalInfo": "La decisión se cierra cuando se aprueba una propuesta",
        "autoCloseAfterDeadline": "Cierre automático tras la fecha límite",
        "cancel": "Deshacer",
        "changeResponsible": "Cambiar responsable",
        "clickToSetDeadline": "Haz clic para establecer la fecha límite",
        "closeDecision": "Cerrar decisión",
        "confirmChoices": "Confirmar opciones",
        "createProposal": "Crear propuesta",
        "create_decisions": "Crear decisión | Crear decisiones",
        "delete": "Eliminar",
        "deleteCount": "Vas a eliminar {count} decisión. ¿Estás seguro? | Vas a eliminar {count} decisiones. ¿Estás seguro?",
        "deleteMultipleDecisions": "Eliminar...",
        "delete_cancel": "Cancelar",
        "delete_decisions": "Eliminar decisión | Eliminar decisiones",
        "edit": "Editar",
        "editBudget": "Editar presupuesto",
        "editDeadline": "Editar fecha límite",
        "editDecision": "Editar decisión",
        "editReminders": "Editar recordatorios",
        "goToDecision": "Ir a la decisión",
        "goToProposal": "Ir a la propuesta",
        "goToSummary": "Ir al resumen",
        "hide": "Despublicar",
        "hideInfo": "Ocultar información",
        "noDescription": "Haz clic para añadir una descripción",
        "openDecision": "Abrir decisión",
        "publish": "Publicar",
        "publishAll": "Para todos",
        "publishCustomer": "Publicar para el cliente",
        "publishPartners": "Publicar para colaborador(es)",
        "reject": "Rechazar",
        "relaunch_decision": "Relanzar decisión",
        "request_changes": "Solicitar cambios",
        "reset": "Restablecer",
        "save": "Guardar",
        "save_and_share_partners": "Guardar y compartir con colaboradores",
        "selectAll": "Seleccionar las {total} unidades",
        "selectChoices": "Seleccionar opciones",
        "share_proposals": "Compartir propuestas",
        "showMoreInfo": "Mostrar más información",
        "stopApproving": "Dejar de aprobar",
        "submit": "Guardar",
        "tickBoxesDeletion": "Marca las casillas de los archivos que quieras eliminar.",
        "unSelectAll": "Limpiar selección.",
        "unpublishForCustomer": "Despublicar para el cliente",
        "unpublishForPartners": "Despublicar para colaborador de la decisión",
        "update": "Actualizar",
        "upload": "Subir",
        "upload_documents": "Subir documentos",
        "upload_proposals": "Crear propuesta"
      },
      "attributes": {
        "amount_gross": "Oferta bruta",
        "amount_net": "Oferta neta",
        "approved_at": "Fecha de aprobación de la propuesta",
        "approved_proposal_name": "Propuesta aprobada",
        "bathrooms": "Número de baños",
        "bedrooms": "Número de dormitorios",
        "category": "Categoría",
        "customer_group_name": "Cliente",
        "decision_name": "Decisión",
        "decisions_count": "{count} decisión | {count} decisiones",
        "due_date": "Fecha límite",
        "floor": "Planta",
        "negative_surcharges_allowed": "Permitir crédito",
        "note_employee": "Nota",
        "price_budget": "Presupuesto",
        "price_budget_extra": "Presupuesto adicional",
        "price_budget_info": "Siempre puedes editar el presupuesto más tarde",
        "price_budget_info_mup": "Siempre puedes editar el presupuesto por unidad más tarde",
        "price_margin": "Margen",
        "price_surcharge": "Mejora",
        "published": "Publicada",
        "responsible": "Responsable",
        "status": "Estado",
        "unit": "Unidad",
        "verification_type": "Decisión de aprobación dada por",
        "visibility": "Visibilidad"
      },
      "edit_actions": {
        "edit_auto_close": "Opciones de cierre automático",
        "edit_close_decision": "Cerrar/Abrir decisión",
        "edit_deadline": "Establecer fecha límite",
        "edit_margin": "Establecer márgenes",
        "edit_negative_surcharges_allowed": "Permitir crédito",
        "edit_not_interested_allowed": "Permitir la opción 'No interesado'",
        "edit_note_employee": "Editar nota",
        "edit_price_budget": "Establecer presupuesto",
        "edit_price_budget_extra": "Establecer presupuesto adicional",
        "edit_reminders": "Establecer recordatorios",
        "edit_responsible": "Establecer responsable"
      },
      "labels": {
        "accessRights": "Permisos de acceso",
        "activity": "Actividad",
        "addDecisionNote": "Añadir nota",
        "addReminders": "Añadir recordatorios",
        "allUnits": "Todas las unidades",
        "allUnitsAssigned": "Todas las unidades asignadas",
        "allow_not_interested": "Permitir la opción 'No interesado'",
        "allow_not_interested_cancel_warning": "Esta decisión está marcada actualmente como 'No interesado'. Desactivar esta opción cancelará el estado 'No interesado'.",
        "allow_not_interested_info": "Muestra una opción 'No interesado' junto a las propuestas",
        "approved": "Aprobada",
        "approvedAt": "Aprobada {approved_at}",
        "approvedProposal": "Propuesta aprobada",
        "askQuestion": "Haz aquí tus preguntas sobre tu decisión {decision}",
        "assignCustomerToUnit": "Asignar cliente",
        "autoClose": "Cierre automático",
        "budgetOverview": "Vista general del presupuesto",
        "budgetSubtitle": "Introduce aquí un presupuesto si se aplica a todas las unidades seleccionadas, o añade los presupuestos más tarde",
        "budgetTitle": "Establecer un presupuesto",
        "checkbox": "Casilla",
        "clickHereToChange": "Haz clic aquí si quieres cambiarlos.",
        "close": "Cerrar",
        "closeDecision": "Cerrar decisión",
        "closed": "La decisión está cerrada para esta unidad. El cliente ya no podrá aprobar una propuesta.",
        "closedLabel": "Cerrada",
        "closed_tag": "Decisión cerrada",
        "closed_tooltip_customer": "La decisión está cerrada. Ya no podrás aprobar una propuesta.",
        "countDocuments": "Aún no hay documentos | 1 documento | {count} documentos",
        "countEdit": "Editar la decisión de {count} unidad | Editar la decisión de {count} unidades",
        "countUpload": "Subir documento(s) a esta unidad | Subir documento(s) a {count} unidades",
        "created_on": "Decisión creada el {date}",
        "custom_columns_title": "Puedes añadir hasta 10 columnas",
        "customer": "Cliente",
        "customer_status": "Estado del cliente",
        "decided": "Decidida",
        "decision": "Decisión",
        "decisionBreadcrumb": "Decisión {decision_type}",
        "decisionNotPublishedYetFor": "Decisión aún no publicada para",
        "decisionNoteExplainer": "Esta nota solo es visible para tu equipo y para los colaboradores autorizados a ver esta decisión",
        "decisionType": "Asunto de la decisión",
        "decisionUnit": "Decisión para la unidad {unit}",
        "decisions": "Decisiones",
        "decisions_all_projects": "Decisiones de todos los proyectos",
        "decisions_breadcrumb": "Decisiones {project}",
        "default": "Predeterminado",
        "deleteExplanation": "Todos los mensajes, archivos, propuestas y demás datos se eliminarán permanentemente de la plataforma. Los clientes y colaboradores relacionados con estas decisiones perderán todo el acceso.",
        "descriptionSubtitle": "Aquí puedes añadir más información para tus clientes",
        "descriptionTitle": "Añade una descripción para tu cliente",
        "documentRequired": "Se requiere un documento firmado para la aprobación",
        "documentUnits": "Carpeta de la unidad",
        "documents": "Documentos",
        "dueDate": "Vence el {date}",
        "due_date_subtitle": "Establece una fecha límite para tomar la decisión",
        "due_date_title": "Fecha límite y recordatorios",
        "editDecisionNote": "Editar nota",
        "extra_options": "Opciones adicionales",
        "false": "No",
        "filter": "Filtro",
        "finalSettings": "Algunos ajustes opcionales",
        "finalSettingsStep": "Ajustes finales",
        "financial": "Financiero",
        "firstThingsfirst": "Antes de nada, algo de información general",
        "follow": "Seguir",
        "following": "Siguiendo — recibirás notificaciones",
        "four": "4",
        "giveNewAmount": "Introduce el nuevo importe",
        "hideCount": "Despublicar esta decisión para 1 unidad | Despublicar la decisión para {count} unidades",
        "hideVisibilitySettings": "Ocultar ajustes de visibilidad",
        "indicate_not_interested": "Indicar que el cliente no está interesado en esta decisión",
        "info": "Mostrar más información",
        "infoCustomers": "Datos del cliente",
        "information": "Información",
        "leaveBudgetEmptyInfo": "Déjalo vacío si no quieres usar mejoras ni crédito",
        "make_a_decision": "Tomar una decisión",
        "marginOnBudget": "Margen sobre el presupuesto (%)",
        "marginOnUpgrades": "Margen sobre las mejoras (%)",
        "marginOnUpgradesExplainer": "El margen sobre las mejoras también se aplicará a los presupuestos adicionales que des a un cliente. El presupuesto adicional se puede establecer dentro de la decisión de una unidad.",
        "marginOverview": "Vista general de márgenes",
        "marginSubTitle": "Calcular márgenes automáticamente como porcentajes",
        "marginTitle": "Usar porcentajes de margen",
        "members": "Miembros",
        "modifyLater": "Puedes modificar estos ajustes más tarde",
        "name": "Nombre",
        "newActivity": "Nueva actividad",
        "newDocument": "Nuevo(s) documento(s)",
        "next": "Siguiente",
        "no": "No",
        "noApprovedProposalYet": "Aún no se ha aceptado ninguna propuesta",
        "noBudget": "Sin presupuesto definido",
        "noCustomer": "Aún no hay cliente",
        "noCustomerAssigned": "Aún no hay ningún cliente asignado a la unidad",
        "noDeadline": "Sin fecha límite",
        "noDecisionDueDate": "Selecciona una fecha límite",
        "noDecisionStartDate": "Sin fecha de inicio establecida",
        "noDecisionsMade": "Aún no se han tomado decisiones",
        "noDecisionsToMake": "No hay decisiones que tomar.",
        "noDecisionsYet": "Aún no hay decisiones",
        "noDocumentsShared": "No se han compartido documentos",
        "noDueDate": "Establece primero una fecha límite antes de configurar los recordatorios",
        "noDueDateSet": "Sin fecha límite establecida",
        "noExtraBudget": "Sin presupuesto adicional",
        "noMessages": "Escribe tu primer mensaje para {decision} en el cuadro de abajo",
        "noUnitDocuments": "Aún no se han añadido documentos a la carpeta de la unidad",
        "noUnitsClick": "Aún no hay unidades, haz clic aquí para añadir",
        "no_result_for_search": "Sin resultados para esta búsqueda filtrada.",
        "no_surcharges": "Sin mejoras",
        "no_surcharges_info": "Propuestas sin mejoras financieras",
        "notDecided": "Aún sin decidir",
        "notDecidedYet": "El cliente aún no ha tomado una decisión.",
        "notFollowing": "No siguiendo — haz clic para recibir notificaciones",
        "notPossibleToWriteMessageDeactivatedUnit": "Esta decisión está relacionada con una unidad desactivada. Ya no es posible escribir un nuevo mensaje.",
        "notPublished": "No publicada",
        "notPublishedCustomer": "Decisión aún no publicada para el cliente",
        "notPublishedPartners": "Decisión aún no publicada para los colaboradores de la decisión",
        "notShared": "No compartido",
        "not_interested": "No interesado",
        "not_interested_customer": "No interesado",
        "not_interested_customer_info": "Si no estás interesado en esta decisión, o no es relevante para ti, haz clic aquí para indicarlo.",
        "not_interested_modal": {
          "customer": {
            "body": "Indica algo más de información sobre por qué no estás interesado en esta decisión",
            "title": "No estoy interesado en esta decisión"
          },
          "employee": {
            "body": "Indica algo más de información sobre por qué el cliente no está interesado en esta decisión. Esta información también será visible para el cliente.",
            "title": "El cliente no está interesado en esta decisión"
          },
          "feedback": "Comentarios"
        },
        "one": "1",
        "open": "Abierta",
        "openDecisionInfo": "Esta decisión está abierta. El cliente puede aprobar propuestas.",
        "open_auto_close_deadline_unit": "Define si la decisión se cerrará automáticamente o no al superar la fecha límite",
        "open_auto_close_unit": "Define si la decisión se cerrará automáticamente o no al aprobarse ",
        "open_close_unit": "la decisión de 1 unidad | la decisión de {unit_count} unidades",
        "or": "o",
        "participants": "Participantes",
        "partners": "Colaboradores de la decisión",
        "pendingDecisions": "1 decisión por tomar | {count} decisiones por tomar",
        "priceBudget": "Presupuesto",
        "priceBudgetExtra": "Presupuesto adicional",
        "proposal": "Propuestas",
        "proposals": "Propuestas | 1 propuesta | {count} propuestas",
        "publish?": "¿Guardar y publicar?",
        "publishNow?": "¿Publicar ahora?",
        "publishTopOfPage": "Puedes publicar esta decisión en la parte superior de esta página",
        "publishedCount": "Publicar esta decisión para 1 unidad | Publicar la decisión para {count} unidades",
        "publishedCustomer": "Decisión publicada para el cliente",
        "publishedCustomerPartners": "Decisión publicada para el cliente y los colaboradores de la decisión",
        "publishedNone": "Aún no publicada",
        "publishedPartners": "Decisión publicada para los colaboradores de la decisión",
        "publishedSince": "Decisión publicada desde {date}",
        "published_info": "Muestra si todas las unidades se han publicado para los clientes y/o los colaboradores de la decisión",
        "remainOpen": "Permanecer abierta",
        "reminders": "Recordatorios",
        "remindersCount": "1 recordatorio | {count} recordatorios",
        "reopenDecision": "Reabrir decisión",
        "requiresDocumentVerification": "Requiere un documento firmado para la aprobación",
        "requiresNoDocumentVerification": "No se requiere un documento firmado para la aprobación",
        "returnToTickets": "Volver",
        "rights": {
          "access_full": "Acceso completo",
          "access_full_info": "Puede compartir mensajes, documentos y propuestas directamente con el cliente",
          "access_full_short": "Completo",
          "access_none": "Acceso restringido",
          "access_none_info": "Sin comunicación con el cliente: solo para uso interno",
          "access_none_short": "Restringido",
          "access_semi": "Acceso básico",
          "access_semi_info": "Puede enviar mensajes al cliente, pero no documentos ni propuestas",
          "access_semi_short": "Básico",
          "customer_show": "Puede ver la información del cliente.",
          "default": "Los colaboradores de la decisión pueden enviar mensajes, subir documentos y crear propuestas para <b>{client_name}</b> en cualquier momento. También tienen acceso a los planos en la carpeta de documentos de la unidad. Debajo puedes editar sus permisos de comunicación con tus clientes.",
          "document_customer": "Puede compartir sus documentos directamente con el cliente.",
          "message_customer": "Puede enviar mensajes al cliente.",
          "proposal_customer": "Puede compartir sus propuestas directamente con el cliente."
        },
        "save?": "¿Guardar?",
        "saveExplainer": "¿Hacer visible esta decisión para tus clientes? ¿O guardarla y publicarla más tarde?",
        "select": "Seleccionar",
        "selectOneUnit": "Selecciona al menos 1 unidad",
        "selectUnits": "Seleccionar unidades",
        "select_units": "Seleccionar unidades",
        "selected": "{selected} unidad seleccionada. | {selected} unidades seleccionadas.",
        "sharedWith": "Compartido con",
        "showDecisionsFor": "Mostrar decisiones para",
        "show_all_units": "Mostrar todas las unidades",
        "signOnline": "Escribe tu nombre para confirmar (predeterminado)",
        "signUploadDocument": "Subir documento firmado",
        "signedDocument": "Subir documento firmado",
        "status": "Estado",
        "statusExplained": "¿Qué significa cada estado de la decisión?",
        "step2Subtitle": "Selecciona tu proyecto para incluir todas tus unidades a la vez.",
        "step2Title": "¿Qué unidades tienen que tomar una decisión?",
        "step2TitleWithDecisionName": "¿Qué unidades tienen que tomar una decisión para {decision_name}?",
        "subject": "Asunto",
        "summary": "Resumen",
        "surcharge_tooltip": "Esta es la mejora de esta decisión",
        "surcharges_total": "Mejoras: {total}",
        "surcharges_total_tooltip": "Este es el importe total de las mejoras de todas las unidades que tienen una mejora",
        "three": "3",
        "tickets": "Conversaciones",
        "toBeDecided": "Por decidir",
        "toDecide": "A decidir",
        "total": "Total",
        "totalSelected": "Las {total} unidades están seleccionadas.",
        "true": "Sí",
        "two": "2",
        "type": "Tipo",
        "unitDecisionsWillBeShownHere": "Las decisiones de la unidad se mostrarán aquí",
        "unitNotActivated": "Solo para unidades activadas",
        "unitSelected": "Ninguna unidad | Una unidad | {count} unidades",
        "unit_name": "Unidad",
        "units": "Unidades",
        "unpublish": "No publicada",
        "unpublished": "Despublicada",
        "uploadDocument": "Subir documentos",
        "useMargins": "Activar porcentajes de margen",
        "use_surcharges": "Usar mejoras",
        "use_surcharges_info": "Establece un presupuesto para las mejoras",
        "validation_errors": "Hay problemas con esta propuesta. Resuélvelos primero e inténtalo de nuevo.",
        "waitingForClient": "Esperando al cliente",
        "whatTheCustomerHasBought": "Lo que ha comprado el cliente",
        "when": "Cuándo",
        "who": "Quién",
        "withAll": "Todos",
        "withClient": "Solo con {client}",
        "withCustomer": "Con el cliente",
        "withCustomerName": "Con {customer}",
        "withPartners": "Solo con los colaboradores de la decisión",
        "yes": "Sí"
      },
      "legend": {
        "all": "Todas las decisiones",
        "approved": "Decidida",
        "approvedAfterDue": "Propuesta aprobada tras la fecha límite",
        "created": "Aún sin propuesta",
        "decisionApproved": "Decidida",
        "hasDecision": "Aún sin propuesta",
        "hasProposal": "Propuesta subida",
        "has_proposal": "Por decidir",
        "isExpired": "Fecha límite vencida, sin propuesta subida",
        "isExpiredHasProposal": "Fecha límite vencida, propuesta subida",
        "noDecision": "Unidad excluida de esta decisión",
        "not_interested": "No interesado",
        "other_decisions": "Otras decisiones",
        "requested_changes": "Cambios solicitados",
        "waiting_for_proposal": "Esperando propuesta"
      },
      "navigation": {
        "backToDecisions": "Volver a decisiones"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "¡Pronto llegarán nuevas decisiones!",
            "title": "Prepárate para tomar una decisión"
          },
          "no_documents": {
            "subtitle": "Aquí encontrarás todos los documentos relacionados con esta decisión",
            "title": "Sube documentos relacionados con la decisión {decision_name}"
          }
        },
        "employees": {
          "conversations": {
            "none": {
              "subtitle": "En cuanto haya un cliente asignado a esta unidad, verás las conversaciones aquí",
              "title": "Aquí encontrarás todas las conversaciones de esta decisión"
            }
          },
          "new": {
            "subtitle": "Asigna una decisión a varias unidades a la vez",
            "title": "Crea tu primera decisión"
          }
        },
        "partners": {
          "none": {
            "subtitle": "Recibirás una notificación por correo electrónico cuando se publique una nueva decisión.",
            "title": "Aún no tienes ninguna decisión"
          }
        }
      },
      "toasts": {
        "bulk_create": "Decisión creada correctamente | Decisiones creadas correctamente",
        "bulk_delete": "Decisión eliminada correctamente | Decisiones eliminadas correctamente",
        "bulk_update": "Decisión actualizada correctamente | Decisiones actualizadas correctamente",
        "update": "Decisión actualizada correctamente"
      },
      "validation": {
        "amountRequired": "El importe es obligatorio",
        "cannotUpdatePrice": "El presupuesto no se puede editar porque ya se han hecho visibles para el cliente cuotas basadas en esta decisión",
        "customer": {
          "need_not_interested_note": "Indica por qué no estás interesado en esta decisión"
        },
        "employee": {
          "need_not_interested_note": "Indica por qué el cliente no está interesado en esta decisión."
        },
        "installmentsSent": "Algunas de las decisiones seleccionadas tienen cuotas visibles para el cliente. Su presupuesto se mantendrá igual.",
        "mustBeZeroOrMore": "Debe ser 0 o más",
        "needAttachment": "Sube al menos un documento nuevo o selecciona uno de la carpeta de la unidad",
        "needNumber": "Se necesita un número (p. ej. 8400.5)",
        "needTitle": "El título es obligatorio",
        "need_responsible": "Se necesita un responsable",
        "priceBudgetNotNegative": "El presupuesto no puede ser un número negativo.",
        "responsibleRequired": "El responsable es obligatorio",
        "selectContactPerson": "Selecciona al menos 1 persona de contacto"
      }
    }
  }
}
